import axios from 'axios';


// export const base_url = 'http://127.0.0.1:8000/api' // api base url
// export const img_url = 'http://127.0.0.1:8000/storage' // api photo url
// export const domain_url = 'http://localhost:3000' // domain url

export const base_url = 'https://api.rezmo.cloud/api'
// export const base_url = 'https://api.smartcafe.az/api'
export const img_url = 'https://api.rezmo.cloud/storage'
export const domain_url = 'https://rezmo.cloud'

// ─────────────────────────────────────────────────────────────────────────────
// QLOBAL SORĞU TIMEOUT-U
//
// axios-un default `timeout` dəyəri 0-dır — YƏNİ SONSUZ. Restoranda internet
// kəsiləndə sorğu OS-un TCP timeout-una qədər (onlarla saniyə) asılı qalır və
// səhifə donur. Bildirişlər səhifəsində məhz bu baş verdi.
//
// POS rejimində pos_local-a gedən sorğular onsuz da yerlidir (millisaniyələr),
// ona görə bu limit yalnız cloud sorğularına təsir edir.
//
// QEYD: `axios.create()` ilə yaradılan instansiyalar bu default-u MİRAS ALIR
// (yalnız interceptor-lar miras alınmır) — ona görə bir sətir hamısını örtür.
// Uzun sürən yükləmə (fayl/şəkil) üçün həmin sorğuda `timeout` açıq verilməlidir.
axios.defaults.timeout = 15000;


// export const base_url = 'https://betaapi.smartcafe.az/api' // api base url
// export const img_url = 'https://betaapi.smartcafe.az/storage' // api photo url
// export const domain_url = 'https://beta.smartcafe.az' // domain url




